<template>
    
    <span>
      <span v-if="isUserPage" >
        <base-button  
                     :class="' btn-danger'"
                     :disabled="editable || isDisabled"
                     link
                     style="right: 14px " 
                     @click="() => showModal = true">
            <i class="tim-icons icon-lock-circle"></i>Lock
        </base-button>
    </span>
    <span v-else >
        <base-button  v-if="isLocked"
                     size="md"
                     :class="' btn_info'"
                     :disabled="editable || isDisabled" 
                     @click="submitUnlocked">
            <i class="tim-icons icon-lock-circle">{{unlockText}}</i>
        </base-button>
        <base-button  v-if="isApproved"
                     size="md"
                     :class="' btn-danger'"
                     :disabled="editable || isDisabled"
                     @click="submitLocked">
            <i class="tim-icons icon-lock-circle">{{lockText}} </i>
        </base-button>
    </span>
    <modal v-on:close="() => showModal = false" :show="showModal" modal-id="lineItemModal" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">Lock User Account</h4>
      <hr />
     
        
          <h4>Please confirm that you would like to lock the account for {{ userName }}</h4>
         
          <template slot="footer">
        <div class="container align-center alert_footer">
            <base-button
            type="danger"
            style="margin-right:10px "
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="showModal = false"
          >
            Cancel
          </base-button>
            <base-button
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="submitLocked"
          >
            Continue
          </base-button>
         
         
        </div>
      </template>
      </modal>
    </span>
    
  
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { BaseButton, Modal } from "@/components";

    export default {
        name: "lock-button",
        props: {
            id: {
                type: [Number,String],
            },
            lockText: {
                type: String,
                default: 'LOCK',
            },
            unlockText: {
                type: String,
                default: 'UNLOCK',
            },
            editable:{
                type: Boolean,
                default: false
            },
            isUserPage: {
                type: Boolean,
                default: false
            },
            userName:{
                type: String,
                default: ''
            }
        },
        components: {
            BaseButton,
            Modal,
        },
        data(){
            return{
            isDisabled: false,
            showModal: false
            }
        }, 
        async mounted(){
        //await this.getUser(this.id)
        },
        computed: {
            ...mapGetters({
                user: "users/user",
                getMyself: "authentication/getUser"
            }),
            isLocked() {
                return this.user.approvalStatusName == "LOCKED" ? true : false;
            },
            isApproved() {
                return this.user.approvalStatusName == "APPROVED" ? true : false;
            },
        },
        methods: {
            ...mapActions({
                lockUser: "users/lockUser",
                unlockUser: "users/unlockUser",
            }),
            async submitLocked(e) {
                if (this.isDisabled) return; // Prevent double-click
                this.isDisabled = true;
                try {
                    await this.lockUser(this.id);
                    this.showModal = false;
                    // Parent component handles user refresh via reloadUnlockLockInfo
                    this.$emit('reloadUnlockLockInfo');
                } finally {
                    this.isDisabled = false;
                }
            },
            async submitUnlocked(e) {
                if (this.isDisabled) return; // Prevent double-click
                this.isDisabled = true;
                try {
                    await this.unlockUser(this.id);
                    this.showModal = false;
                    // Parent component handles user refresh via reloadUnlockLockInfo
                    this.$emit('reloadUnlockLockInfo');
                } finally {
                    this.isDisabled = false;
                }
            }
        },
    };
</script>
